export class STORAGEKEYS{
    public static ACESS_TOKEN = "ACCESS_TOKEN";
    public static TEXT_CONTENTS_STATE = "TEXT_CONTENTS_STATE";
    public static LEN_CONFIG_STATE = "LEN_CONFIG_STATE";
    public static LOAN_CALCULATOR_STATE = "LOAN_CALCULATOR_STATE";

    public static AFFILIATE_LINK_SEARCH_PARAMS_COOKIE = "AFFILIATE_LINK_SEARCH_PARAMS_COOKIE"
    public static AFFILIATE_ALTERNATIVE_OFFERT_NAME = "AFFILIATE_ALTERNATIVE_OFFERT_NAME"
}